import React from 'react';
import { Link } from 'react-router-dom';
import title from '../assets/title.png';
import '../App.css';

const HomePage: React.FC = () => {
  return (
    <div className="App">
      <header className="landing-hero">
        <img src={title} className="Title" alt="Bye For Now" />
        <p className="hero-tagline">
          Stay in touch like you never stopped hanging out
        </p>
        <div className="RowItems">
          <a href="https://apps.apple.com/us/app/monogatari/id6502987623">
            <button className="store-button store-button-primary">
              Download on the App Store
            </button>
          </a>
          <a href="https://play.google.com/store/apps/details?id=org.monogatari.project">
            <button className="store-button store-button-primary">
              Get it on Google Play
            </button>
          </a>
        </div>
      </header>

      <section className="landing-screenshots">
        <h2 className="screenshots-title">How it works</h2>
        <div className="screenshots-row">
          <div className="screenshot-card">
            <img src="/screenshots/screenshot-home.png" alt="Bye For Now home screen showing which friends are free" className="screenshot-img" />
            <h3 className="screenshot-title">Your home base</h3>
            <p className="screenshot-desc">See who&apos;s free right now. When you&apos;re home and a friend is too, you&apos;re one tap from talking.</p>
          </div>
          <div className="screenshot-card">
            <img src="/screenshots/screenshot-reach.png" alt="Reaching a friend after one tap" className="screenshot-img" />
            <h3 className="screenshot-title">One tap to talk</h3>
            <p className="screenshot-desc">Tap once and your voice plays live for a friend who&apos;s home and free, like a walkie-talkie. No dialing, no ringing, nothing to accept.</p>
          </div>
          <div className="screenshot-card">
            <img src="/screenshots/screenshot-call.png" alt="A live hands-free call with friends" className="screenshot-img" />
            <h3 className="screenshot-title">Just hang out</h3>
            <p className="screenshot-desc">You&apos;re connected, hands-free. Talk as long as you like, then say bye for now.</p>
          </div>
          <div className="screenshot-card">
            <img src="/screenshots/screenshot-places.png" alt="Saving the places where you can be reached" className="screenshot-img" />
            <h3 className="screenshot-title">Only where you choose</h3>
            <p className="screenshot-desc">Save up to three places. Friends can reach you only while you&apos;re at one, never during quiet hours, and your location never leaves your phone.</p>
          </div>
        </div>
      </section>

      <section className="landing-ptt">
        <h2 className="screenshots-title">Talk without opening the app</h2>
        <p className="ptt-intro">
          While you&apos;re home, talking is one press away on both platforms.
        </p>
        <div className="ptt-row">
          <div className="ptt-card">
            <span className="ptt-platform">iPhone</span>
            <img src="/screenshots/ptt-ios.png" alt="The system Push to Talk bar on iPhone" className="ptt-img" />
            <p className="screenshot-desc">Bye For Now lives in the system Push to Talk bar at the top of your screen. Press and hold Talk to go live.</p>
          </div>
          <div className="ptt-card">
            <span className="ptt-platform">Android</span>
            <img src="/screenshots/ptt-android.png" alt="The Bye For Now notification with a mic button on Android" className="ptt-img" />
            <p className="screenshot-desc">A quiet notification is there whenever you&apos;re home. Expand it and tap the mic to talk.</p>
          </div>
        </div>
      </section>

      <footer className="landing-footer">
        <div className="footer-links">
          <Link to="/support">
            <button className="store-button">Support</button>
          </Link>
          <Link to="/privacy">
            <button className="store-button">Privacy Policy</button>
          </Link>
          <Link to="/libraries">
            <button className="store-button">Libraries</button>
          </Link>
          <Link to="/deleteAccount">
            <button className="store-button">Delete Account</button>
          </Link>
        </div>
      </footer>
    </div>
  );
};

export default HomePage;
